import {
  setMessagesFailed,
  setMessagesPending,
  setSynchronizationMessagesFulfilled,
  setSynchronizationMessagesPending,
} from './actions';
import { fetchHistoryMessages, HISTORY_MESSAGES_REQUEST_LIMIT } from '../../services/fetchHistoryMessages';
import { ERequestApiStatus } from '../../types/appState';
import { TMessageSchema } from '../../types/messages';
import { TThunkAction } from '../../types/redux/thunk';
import { checkNeedUpdateMessages } from '../../utils/checkNeedUpdateMessages';
import { getHashFromRowVersions } from '../../utils/getHashFromRowVersions/getHashFromRowVersions';

/**
 * Синхронизация сообщений по http
 */
export const synchronizationMessages =
  (
    chatId: string,
    isOnlyCheckUpdate: boolean = false,
    offset: number = 0,
    createdAt?: string,
  ): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const {
      custom: { messagesMap },
    } = context;
    const state = getState();

    const { openedChats } = state;

    const currentChat = openedChats[chatId];

    if (!currentChat || currentChat.status === ERequestApiStatus.Pending) {
      return;
    }

    const messages = currentChat.chatMessages;

    const rowVersions = messages
      .slice(offset, HISTORY_MESSAGES_REQUEST_LIMIT + offset)
      .map(message => `${message.message.rowVersion}` || '');

    if (rowVersions.length === 0) {
      return;
    }

    const rowVersionsHash = getHashFromRowVersions(rowVersions);

    if (isOnlyCheckUpdate) {
      dispatch(setSynchronizationMessagesPending({ chatId }));
    } else {
      // TODO вынести переход в другой чат более явно
      dispatch(setMessagesPending({ chatId }));
    }
    const result = await fetchHistoryMessages(context, {
      parameters: {
        chatId,
        rowVersionsHash,
        createdAt: createdAt ? createdAt : undefined,
      },
    });

    const { error, response } = result;

    if (response !== null) {
      dispatch(
        setSynchronizationMessagesFulfilled({
          chatId,
          messages: response.messages as TMessageSchema[],
          messagesMap,
        }),
      );

      const earliestResultMessageTs = response.messages[response.messages.length - 1]
        ? response.messages[response.messages.length - 1].created
        : '';

      const needUpdateMessages = checkNeedUpdateMessages(
        messages,
        response.canLoadMore,
        earliestResultMessageTs,
        HISTORY_MESSAGES_REQUEST_LIMIT,
        offset,
      );

      if (needUpdateMessages) {
        dispatch(
          synchronizationMessages(chatId, isOnlyCheckUpdate, rowVersions.length + offset, earliestResultMessageTs),
        );
      }

      return;
    }

    dispatch(setMessagesFailed({ chatId, error }));
  };
